import { setAxiosCallsInterceptors } from '@shared/logging/setAxiosCallsInterceptors';
import { getValidatedBase64Cookie } from '@shared/cookies/getValidatedBase64Cookie';
import { createTransactionId } from '@shared/transactionId/createTransactionId';
import { consoleLogger } from '@shared/logging/consoleLogger';
import { UtiqStatusEntryName } from '@shared/constants/utiq';
import { Environments } from '@shared/environment/environments';
import { initializeUtiqFlow } from './initializeUtiqFlow';
import { initializeSharedApiFunctions } from '@shared/api/initializeSharedApiFunctions';
import { initializeCommandQueue } from '@utiqLoader/initializeCommandQueue';
import { initializeUtiqAPI } from '@utiqLoader/initializeUtiqAPI';
import { initializeConsoleLogger } from '@shared/logging/initializeConsoleLogger';
import { initializeConfigAPIFunctions } from '@shared/config/initializeConfigAPIFunctions';
import { setIframeEventHandler } from '@utiqLoader/setIframeEventHandler';
import { utiqMachine } from '../machine';
import { setupCMPBeforeUtiq, setupCMPAfterUtiq } from './CMP/setup';

(async () => {
  await utiqMachine.run();
  initializeUtiqAPI();
  initializeConfigAPIFunctions();
  const environment = Environments.Utiq;

  initializeConsoleLogger(environment);

  initializeSharedApiFunctions(environment);
  setIframeEventHandler();
  setAxiosCallsInterceptors();

  const utiqConsentStatusCookie = getValidatedBase64Cookie(
    document.cookie,
    UtiqStatusEntryName,
  );

  /* Create the transactionId that is added to each backend call to track same-pageload calls in logs - in the Utiq namespace */
  createTransactionId(Environments.Utiq);

  /* API method to get Utiq consent status */
  window.Utiq ||= {};
  window.Utiq.API ||= {};
  window.Utiq.API.getUtiqConsentStatus = () => {
    const currentConsentStatusCookie = getValidatedBase64Cookie(
      document.cookie,
      UtiqStatusEntryName,
    );
    if (currentConsentStatusCookie) {
      return currentConsentStatusCookie === 'true';
    }
    return undefined;
  };

  if (utiqConsentStatusCookie === '') await setupCMPBeforeUtiq();
  await initializeUtiqFlow({ utiqConsentStatusCookie, environment });
  initializeCommandQueue();
  await setupCMPAfterUtiq();

  consoleLogger.logInfo('Utiq library loaded...');
})();
